const Modal = require('app/ui/Modal');
const GraphQLMutation = require('app/graphql/Mutation');

class PDFModal {

    defaultOptions() {
        return {
            'id': window.uniqid(),
            'title': '',
            'mutation': 'ExportAnalysisRestaurant',
            'restaurant': null,
            'onClose': function(event){},
            'onShown': function(event){},
            'onNewRestofutePrice': function(){}
        };
    }

    constructor(options) {
        this.settings = $.extend(this.defaultOptions(), options);

        this.onClickExportWithHeader = this.onClickExportWithHeader.bind(this);
        this.onClickExportWithoutHeader = this.onClickExportWithoutHeader.bind(this);

        this.restaurant = this.settings.restaurant;
        if(!this.restaurant.id){
            window.notify("Missing restaurant object in ExportPDFModal","danger");
        }

        this.initialize();
    }

    initialize() {
        var self = this;

        this.build();
    }

    build(){

        this.$content = $('<div/>')
        .addClass('restaurant-analyse-export-pdf-modal');

        this.modal = new Modal({
            'id': this.settings.id,
            'title': this.settings.title,
            'showHeader': false,
            'showFooter': false,
            'content' : this.$content,
            'modalSize': "xl",

            'onShown':this.settings.onShown,
            'onClose':this.settings.onClose,
        })

        this.buildContent();

        this.modal.show();
    }

    refresh(){
        this.buildContent();
    }

    buildContent(){

        let commentLabel = window.translate('app.restaurant.show.tabs.analyse.export.pdf.comment.label');
        let commentPlaceholder = window.translate('app.restaurant.show.tabs.analyse.export.pdf.comment.placeholder');

        this.$textareaComment = $("<textarea/>")
        .attr('name','comment')
        .attr('id','comment')
        .attr('rows',10)
        .addClass('form-control')
        .attr('placeholder',commentPlaceholder);

        let $commentContainer = $('<div/>')
        .addClass('form-group')
        .append(
            $('<label/>')
            .attr('for','comment')
            .addClass('text-muted')
            .append(commentLabel)
        )
        .append(this.$textareaComment);



        this.$btnExportWithHeader = $("<button/>")
        .attr('type','button')
        .addClass('btn btn-primary')
        .append(window.translate('app.restaurant.show.tabs.analyse.export.pdf.withHeader.label'))
        .on('click',this.onClickExportWithHeader);


        this.$btnExportWithoutHeader = $("<button/>")
        .attr('type','button')
        .addClass('btn btn-success')
        .append(window.translate('app.restaurant.show.tabs.analyse.export.pdf.withoutHeader.label'))
        .on('click',this.onClickExportWithoutHeader);

        this.$resultContainer = $('<div/>')
        .hide();

        this.$content
        .html('');

        if(this.settings.mutation != 'ExportAnalysisRestaurantProducts'){
            this.$content.append($commentContainer);
        }

        this.$content
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center mt-4')
            .append(
                $('<h5/>')
                .addClass('text-muted')
                .append(window.translate('app.restaurant.show.tabs.analyse.export.pdf.choose'))
            )
        )
        .append(
            $('<div/>')
            .addClass('row')
            .append(
                $('<div/>')
                .addClass('col-6 p-4 d-flex justify-content-center')
                .append(this.$btnExportWithHeader )
            )
            .append(
                $('<div/>')
                .addClass('col-6 p-4 d-flex justify-content-center')
                .append(this.$btnExportWithoutHeader )
            )
        )
        .append(
            $('<div/>')
            .addClass('d-flex justify-content-center')
            .append(this.$resultContainer)
        )
    }

    onClickExportWithHeader(event){
        event.preventDefault();
        event.stopPropagation();
        this.generateFile(true);
    }

    onClickExportWithoutHeader(event){
        event.preventDefault();
        event.stopPropagation();
        this.generateFile(false);
    }


    generateFile(withHeader){
        var self = this;

        this.$resultContainer
        .html('')
        .append(window.App.generateLoader())
        .show();

        this.$btnExportWithHeader.attr('disabled','disabled');
        this.$btnExportWithoutHeader.attr('disabled','disabled');

        let fields = [
            'success',
            'message',
            'file { url id }',
            'errors { key, value }',
        ];
        let variables = {
            'restaurant': {
                'value': this.restaurant.id,
                'type': 'Int!'
            },
            'type':{
                'value': 'pdf',
                'type': "String!"
            },
            'includeHeader':{
                'value': withHeader ? true : false,
                'type': "Boolean"
            }
        };

        let comment = this.$textareaComment.val();
        if(comment){
            variables['comment'] = {
                'type': 'String',
                'value': comment
            }
        }
        let mutation = new GraphQLMutation({
            //Mutation parameters
            'mutationType': this.settings.mutation,
            'fields': fields,
            'variables': variables,//format: {NAME:{'type':TYPE, 'value': VALUE}}

            //callbacks
            'before': function(){
            },
            'success': function(data){
                if(data.success){
                    self.showResult(data);
                }else{
                    window.notify(data.message,'error');
                }
            },
            'error': function(message, xhr){
                window.notify(message,'error');
            },
            'after': function(){
                self.$btnExportWithHeader.removeAttr('disabled');
                self.$btnExportWithoutHeader.removeAttr('disabled');
            }
        });
        mutation.execute();

    }

    showResult(data){
        let url = window.App.get('apiBaseUrl')+data.file.url;

        let $buttonShow = $('<a/>')
        .attr('target','_blank')
        .attr('href',url)
        .addClass('btn btn-danger')
        .append(
            $('<i/>')
            .addClass("fas fa-file-pdf me-1")
        )
        .append(window.translate('app.restaurant.show.tabs.analyse.export.pdf.open.label'))


        this.$resultContainer
        .html('')
        .append($buttonShow)
        .show();
    }
}

module.exports = PDFModal;

